// load dependencies
import get from "lodash/get";
import getCycleCardAuthorName from "./get-cycle-card-author-name";
import { S3 } from "../constants";
import generateAvatarSVG from "./generate-avatar-svg";
import generateNoImageCycleSvg from "./generate-cycle-no-image-svg";

const getCycleCardImagePath = (cycle) => {
  // if a cycle has an uploaded image, return a path to that in s3
  if (get(cycle, "image.file", false)) {
    const environment = process.env.NODE_ENV
      ? process.env.NODE_ENV
      : "production";
    return `${S3.PATH}appfiles/${environment}/images/${cycle.image.file}`;
  } else {
    // if it doesn't have an image, get name of the cycle and generate an svg

    return generateNoImageCycleSvg(cycle.name);
  }
};

export default getCycleCardImagePath;
